import { useState, useEffect } from 'react';
import { useAction } from 'convex/react';
import { api } from '../../api';
import { useEffectiveSerial } from './useEffectiveSerial';

export interface InstalledApp {
  trackId: string;
  version?: string;
}

export const useInstalledApps = () => {
  const { serial } = useEffectiveSerial();
  const [installedApps, setInstalledApps] = useState<InstalledApp[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Use the updates action to get installed apps
  const updatesAction = useAction(api.apps.list.updates);

  useEffect(() => {
    const loadInstalledApps = async () => {
      if (!serial) {
        setIsLoading(false);
        setInstalledApps([]);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        
        console.log('Loading installed apps for serial:', serial);
        const result = await updatesAction({ serial });
        console.log('Device library result:', result);
        
        setInstalledApps(result);
      } catch (err) {
        console.error('Error loading installed apps:', err);
        setError(err instanceof Error ? err.message : 'Failed to load installed apps');
        setInstalledApps([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadInstalledApps();
  }, [serial, updatesAction]);

  return {
    installedApps,
    isLoading,
    error,
    serial
  };
};
